var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "languages-form" },
    [
      _c("panel-competition-form-box", { staticClass: "mat16" }, [
        _c("div", { staticClass: "w-full mab16" }, [
          _c("p", { staticClass: "section-title" }, [
            _vm._v("Informacje o zawodach"),
          ]),
        ]),
        _c("div", { staticClass: "w-full" }, [
          _c("p", { staticClass: "field-label mab8" }, [
            _vm._v("Opis zawodów"),
          ]),
          _c("div", { staticClass: "i18n-pair i18n-pair--fill" }, [
            _c("div", { staticClass: "i18n-col" }, [
              _c("p", {
                staticClass: "i18n-text i18n-text--border",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.formatHtml(_vm.baseCompetition.description)
                  ),
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "i18n-col i18n-col--area" },
              [
                _c("panel-input-area", {
                  attrs: { rows: 12 },
                  model: {
                    value: _vm.translationCompetition.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.translationCompetition, "description", $$v)
                    },
                    expression: "translationCompetition.description",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "w-full mat24" }, [
          _c("p", { staticClass: "field-label mab8" }, [
            _vm._v("Ważny komunikat"),
          ]),
          _c("div", { staticClass: "i18n-pair i18n-pair--fill" }, [
            _c("div", { staticClass: "i18n-col" }, [
              _c("p", {
                staticClass: "i18n-text i18n-text--border",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.formatHtml(_vm.baseCompetition.remarks)
                  ),
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "i18n-col i18n-col--area" },
              [
                _c("panel-input-area", {
                  attrs: { rows: 4 },
                  model: {
                    value: _vm.translationCompetition.remarks,
                    callback: function ($$v) {
                      _vm.$set(_vm.translationCompetition, "remarks", $$v)
                    },
                    expression: "translationCompetition.remarks",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "w-full mat24" }, [
          _c("p", { staticClass: "field-label mab8" }, [
            _vm._v("Oficjalna strona zawodów"),
          ]),
          _c("div", { staticClass: "i18n-pair i18n-pair--center" }, [
            _c("div", { staticClass: "i18n-col" }, [
              _c("p", { staticClass: "i18n-text i18n-text--border" }, [
                _vm._v(_vm._s(_vm.baseCompetition.website || "—")),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "i18n-col" },
              [
                _c("panel-input-text", {
                  attrs: { hint: "http://" },
                  model: {
                    value: _vm.translationCompetition.website,
                    callback: function ($$v) {
                      _vm.$set(_vm.translationCompetition, "website", $$v)
                    },
                    expression: "translationCompetition.website",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm.hasCycle
          ? _c("div", { staticClass: "w-full mat24" }, [
              _c("p", { staticClass: "field-label mab8" }, [
                _vm._v("Zawody cykliczne"),
              ]),
              _c("div", { staticClass: "i18n-pair i18n-pair--center" }, [
                _c("div", { staticClass: "i18n-col" }, [
                  _c("p", { staticClass: "i18n-text i18n-text--border" }, [
                    _vm._v(_vm._s(_vm.baseCycleName || "—")),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "i18n-col" },
                  [
                    _c("panel-input-text", {
                      model: {
                        value: _vm.local.cycle.translation.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.local.cycle.translation, "name", $$v)
                        },
                        expression: "local.cycle.translation.name",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.local.classifications && _vm.local.classifications.length
        ? _c(
            "panel-competition-form-box",
            { staticClass: "mat16" },
            [
              _c("div", { staticClass: "w-full mab16" }, [
                _c("p", { staticClass: "section-title" }, [
                  _vm._v("Klasyfikacje i kategorie"),
                ]),
              ]),
              _c("div", { staticClass: "w-full mab8" }, [
                _c("p", { staticClass: "field-label" }, [
                  _vm._v("Nazwa klasyfikacji"),
                ]),
              ]),
              _vm._l(
                _vm.local.classifications,
                function (classification, cIdx) {
                  return _c(
                    "div",
                    {
                      key: classification.id,
                      staticClass: "w-full classification-block",
                      class: { mat16: cIdx > 0 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "i18n-pair i18n-pair--center" },
                        [
                          _c("div", { staticClass: "i18n-col" }, [
                            _c(
                              "p",
                              { staticClass: "i18n-text i18n-text--strong" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (classification.base &&
                                        classification.base.name) ||
                                        "—"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "i18n-col" },
                            [
                              _c("panel-input-text", {
                                model: {
                                  value: classification.translation.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      classification.translation,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "classification.translation.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      classification.specialCategories &&
                      classification.specialCategories.length
                        ? _c("div", { staticClass: "categories-pair" }, [
                            _c(
                              "div",
                              { staticClass: "i18n-col categories-col" },
                              _vm._l(
                                classification.specialCategories,
                                function (category) {
                                  return _c(
                                    "p",
                                    {
                                      key: `base-${category.id}`,
                                      staticClass:
                                        "i18n-text i18n-text--nested",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            (category.base &&
                                              category.base.name) ||
                                              "—"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _c(
                              "div",
                              { staticClass: "i18n-col categories-col" },
                              _vm._l(
                                classification.specialCategories,
                                function (category) {
                                  return _c(
                                    "div",
                                    {
                                      key: category.id,
                                      staticClass: "category-input",
                                    },
                                    [
                                      _c("panel-input-text", {
                                        model: {
                                          value: category.translation.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              category.translation,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "category.translation.name",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.local.inputs && _vm.local.inputs.length
        ? _c(
            "panel-competition-form-box",
            { staticClass: "mat16" },
            [
              _c("div", { staticClass: "w-full mab16" }, [
                _c("p", { staticClass: "section-title" }, [
                  _vm._v("Pola dodatkowe formularza"),
                ]),
              ]),
              _vm._l(_vm.local.inputs, function (input, iIdx) {
                return _c(
                  "div",
                  {
                    key: input.id,
                    staticClass: "w-full",
                    class: { mat24: iIdx > 0 },
                  },
                  [
                    _c("p", { staticClass: "field-label mab8" }, [
                      _vm._v(_vm._s(_vm.inputTypeLabel(input.type))),
                    ]),
                    input.type === "fc"
                      ? [
                          _c(
                            "div",
                            { staticClass: "i18n-pair i18n-pair--fill" },
                            [
                              _c("div", { staticClass: "i18n-col" }, [
                                _c("p", {
                                  staticClass: "i18n-text i18n-text--border",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formatHtml(
                                        input.base && input.base.description
                                      )
                                    ),
                                  },
                                }),
                              ]),
                              _c(
                                "div",
                                { staticClass: "i18n-col i18n-col--area" },
                                [
                                  _c("panel-input-area", {
                                    attrs: { rows: 3 },
                                    model: {
                                      value: input.translation.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          input.translation,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "input.translation.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      : input.type === "fs" || input.type === "fr"
                      ? [
                          _c(
                            "div",
                            { staticClass: "i18n-pair i18n-pair--center mab8" },
                            [
                              _c("div", { staticClass: "i18n-col" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "i18n-text i18n-text--strong i18n-text--border",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (input.base && input.base.name) || "—"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "i18n-col" },
                                [
                                  _c("panel-input-text", {
                                    model: {
                                      value: input.translation.name,
                                      callback: function ($$v) {
                                        _vm.$set(input.translation, "name", $$v)
                                      },
                                      expression: "input.translation.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "categories-pair" }, [
                            _c(
                              "div",
                              { staticClass: "i18n-col categories-col" },
                              _vm._l(
                                _vm.inputOptions(input),
                                function (option, oIdx) {
                                  return _c(
                                    "p",
                                    {
                                      key: `base-opt-${input.id}-${oIdx}`,
                                      staticClass:
                                        "i18n-text i18n-text--nested",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.baseInputOption(input, oIdx)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _c(
                              "div",
                              { staticClass: "i18n-col categories-col" },
                              _vm._l(
                                _vm.inputOptions(input),
                                function (option, oIdx) {
                                  return _c(
                                    "div",
                                    {
                                      key: `${input.id}-opt-${oIdx}`,
                                      staticClass: "category-input",
                                    },
                                    [
                                      _c("panel-input-text", {
                                        attrs: { value: option },
                                        on: {
                                          input: function ($event) {
                                            return _vm.setOption(
                                              input,
                                              oIdx,
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "i18n-pair i18n-pair--center" },
                            [
                              _c("div", { staticClass: "i18n-col" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass: "i18n-text i18n-text--border",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        (input.base && input.base.name) || "—"
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "i18n-col" },
                                [
                                  _c("panel-input-text", {
                                    model: {
                                      value: input.translation.name,
                                      callback: function ($$v) {
                                        _vm.$set(input.translation, "name", $$v)
                                      },
                                      expression: "input.translation.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _c("panel-competition-form-box", { staticClass: "mat16" }, [
        _c("div", { staticClass: "w-full mab16" }, [
          _c("p", { staticClass: "section-title" }, [
            _vm._v("Pliki dla uczestnika"),
          ]),
        ]),
        _c("div", { staticClass: "w-full" }, [
          _c("p", { staticClass: "field-label mab8" }, [
            _vm._v("Regulamin zawodów"),
          ]),
          _c("div", { staticClass: "i18n-pair i18n-pair--center" }, [
            _c("div", { staticClass: "i18n-col" }, [
              _c(
                "p",
                { staticClass: "i18n-text i18n-text--border" },
                [
                  _vm.baseCompetition.statuteLink
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.baseCompetition.statuteLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.baseCompetition.statuteLink) + " "
                          ),
                        ]
                      )
                    : [_vm._v("—")],
                ],
                2
              ),
            ]),
            _c(
              "div",
              { staticClass: "i18n-col" },
              [
                _c("panel-input-text", {
                  attrs: { hint: "http://" },
                  model: {
                    value: _vm.translationCompetition.statuteLink,
                    callback: function ($$v) {
                      _vm.$set(_vm.translationCompetition, "statuteLink", $$v)
                    },
                    expression: "translationCompetition.statuteLink",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm.translationCompetition.statementContents &&
        _vm.translationCompetition.statementContents.length
          ? _c(
              "div",
              { staticClass: "w-full mat24" },
              [
                _c("p", { staticClass: "field-label mab8" }, [
                  _vm._v("Zgody uczestników"),
                ]),
                _c("p", { staticClass: "field-hint mab16" }, [
                  _vm._v(
                    " Możesz korzystać ze znaczników html: <b>, <i>, <u>, <br>. "
                  ),
                ]),
                _vm._l(
                  _vm.translationCompetition.statementContents,
                  function (content, sIdx) {
                    return _c(
                      "div",
                      {
                        key: `statement-${sIdx}`,
                        staticClass: "i18n-pair i18n-pair--fill mat8",
                      },
                      [
                        _c("div", { staticClass: "i18n-col" }, [
                          _c("p", {
                            staticClass: "i18n-text i18n-text--border",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formatHtml(_vm.baseStatementContent(sIdx))
                              ),
                            },
                          }),
                        ]),
                        _c(
                          "div",
                          { staticClass: "i18n-col i18n-col--area" },
                          [
                            _c("panel-input-area", {
                              attrs: { value: content, rows: 6 },
                              on: {
                                input: function ($event) {
                                  return _vm.setStatementContent(sIdx, $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }
                ),
              ],
              2
            )
          : _vm._e(),
      ]),
      _c("panel-competition-form-box", { staticClass: "mat16" }, [
        _c("div", { staticClass: "w-full mab16" }, [
          _c("p", { staticClass: "section-title" }, [
            _vm._v("Potwierdzenie rejestracji"),
          ]),
        ]),
        _c("div", { staticClass: "w-full" }, [
          _c("p", { staticClass: "field-label mab8" }, [
            _vm._v("Treść e-maila z potwierdzeniem rejestracji"),
          ]),
          _c("p", { staticClass: "field-hint mab16" }, [
            _vm._v(
              " imię [firstname], nazwisko [lastname], data startu [date], godzina startu [time] "
            ),
          ]),
          _c("div", { staticClass: "i18n-pair i18n-pair--fill" }, [
            _c("div", { staticClass: "i18n-col" }, [
              _c("p", {
                staticClass: "i18n-text i18n-text--border",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.formatHtml(_vm.baseCompetition.registerMailContent)
                  ),
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "i18n-col i18n-col--area" },
              [
                _c("panel-input-area", {
                  attrs: { rows: 10 },
                  model: {
                    value: _vm.translationCompetition.registerMailContent,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.translationCompetition,
                        "registerMailContent",
                        $$v
                      )
                    },
                    expression: "translationCompetition.registerMailContent",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }